var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationsFunnelPagesConfirmationPage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 192,
    viewBox: "0 0 128 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 192,
    fill: "#E0EEFF",
    rx: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 52,
    r: 24,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0072FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.293 10.693c.39-.39 1.024-.39 1.414 0 .36.36.388.928.083 1.32l-.083.094-9 9c-.36.36-.928.388-1.32.083l-.094-.083-5-5c-.39-.39-.39-1.024 0-1.414.36-.36.928-.388 1.32-.083l.094.083L14 18.985l8.293-8.292z",
    transform: "translate(48 36)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 16,
    x: 16,
    y: 120,
    fill: "#FFF",
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 144)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 32,
    fill: "#0072FF",
    rx: 16
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M21.35 20.1c1.864 0 2.99-1.24 3.156-2.579l-1.555-.007c-.146.778-.757 1.225-1.577 1.225-1.104 0-1.854-.82-1.854-2.375 0-1.513.74-2.376 1.865-2.376.841 0 1.449.486 1.566 1.285h1.555c-.202-1.68-1.473-2.645-3.157-2.645-1.92 0-3.387 1.356-3.387 3.736 0 2.372 1.441 3.735 3.387 3.735zm5.58.003c.805 0 1.327-.352 1.594-.86h.042V20h1.435v-3.679c0-1.3-1.1-1.847-2.315-1.847-1.307 0-2.166.625-2.376 1.62l1.4.113c.102-.362.425-.628.969-.628.515 0 .81.26.81.707v.02c0 .352-.374.399-1.322.49-1.08.1-2.049.463-2.049 1.68 0 1.08.77 1.627 1.811 1.627zm.433-1.044c-.466 0-.8-.217-.8-.632 0-.426.352-.636.885-.71.33-.047.87-.125 1.05-.245v.578c0 .572-.471 1.009-1.135 1.009zM32.48 20v-7.273h-1.513V20h1.513zm2.512 0v-7.273H33.48V20h1.513zm5.29.075c.39-.015.667-.093.82-.142l-.238-1.126c-.074.014-.234.05-.376.05-.302 0-.512-.114-.512-.533v-2.642h1.027v-1.137h-1.027V13.24h-1.512v1.306h-.746v1.137h.746v2.84c-.007 1.07.72 1.599 1.818 1.553zm3.904.032c1.654 0 2.684-1.133 2.684-2.813 0-1.69-1.03-2.82-2.684-2.82-1.655 0-2.685 1.13-2.685 2.82 0 1.68 1.03 2.813 2.685 2.813zm.007-1.172c-.764 0-1.154-.7-1.154-1.652 0-.951.39-1.654 1.154-1.654.75 0 1.14.703 1.14 1.654 0 .952-.39 1.652-1.14 1.652zm7.122 1.168c.806 0 1.328-.352 1.595-.86h.042V20h1.435v-3.679c0-1.3-1.101-1.847-2.315-1.847-1.307 0-2.167.625-2.376 1.62l1.399.113c.103-.362.426-.628.97-.628.514 0 .81.26.81.707v.02c0 .352-.374.399-1.322.49-1.08.1-2.049.463-2.049 1.68 0 1.08.77 1.627 1.811 1.627zm.433-1.044c-.465 0-.799-.217-.799-.632 0-.426.352-.636.885-.71.33-.047.87-.125 1.05-.245v.578c0 .572-.472 1.009-1.136 1.009zm6.07 1.048c1.453 0 2.366-.853 2.437-2.106h-1.428c-.089.582-.472.909-.99.909-.707 0-1.166-.593-1.166-1.637 0-1.03.462-1.62 1.165-1.62.554 0 .91.366.991.91h1.428c-.064-1.261-1.02-2.089-2.444-2.089-1.654 0-2.677 1.147-2.677 2.82 0 1.658 1.005 2.813 2.684 2.813zm5.382-.032c.39-.015.667-.093.82-.142l-.238-1.126c-.075.014-.234.05-.376.05-.302 0-.512-.114-.512-.533v-2.642h1.027v-1.137h-1.027V13.24h-1.513v1.306h-.745v1.137h.745v2.84c-.007 1.07.721 1.599 1.819 1.553zm2.256-6.233c.45 0 .82-.344.82-.767 0-.419-.37-.763-.82-.763-.448 0-.817.344-.817.763 0 .423.37.767.817.767zM66.21 20v-5.455h-1.513V20h1.513zm3.463.107c1.655 0 2.685-1.133 2.685-2.813 0-1.69-1.03-2.82-2.685-2.82s-2.684 1.13-2.684 2.82c0 1.68 1.03 2.813 2.684 2.813zm.007-1.172c-.763 0-1.154-.7-1.154-1.652 0-.951.39-1.654 1.154-1.654.75 0 1.14.703 1.14 1.654 0 .952-.39 1.652-1.14 1.652zM74.65 20v-3.153c.003-.704.422-1.115 1.033-1.115.607 0 .973.397.97 1.065V20h1.512v-3.473c0-1.271-.746-2.053-1.882-2.053-.81 0-1.396.398-1.64 1.034h-.065v-.963h-1.441V20h1.513z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 8,
    x: 16,
    y: 88,
    fill: "#338EFF",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 8,
    x: 16,
    y: 104,
    fill: "#99C7FF",
    rx: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E0EEFF",
    d: "M4 0h120c2.21 0 4 1.79 4 4v12H0V4c0-2.21 1.79-4 4-4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 8,
    r: 3,
    fill: "#25CF1B"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#99C7FF",
    d: "M0 16.5L128 16.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 8,
    r: 3,
    fill: "#F20D5D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 8,
    r: 3,
    fill: "#F9C206"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 8,
    x: 36,
    y: 4,
    fill: "#FFF",
    rx: 2
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationsFunnelPagesConfirmationPage);
export default __webpack_public_path__ + "static/media/illustrations-funnel-pages-confirmation-page.ca811396.svg";
export { ForwardRef as ReactComponent };